const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-6 mt-12">
      <div className="max-w-7xl mx-auto px-8 text-center text-sm text-gray-600">
        <p>
          © 2026 timelined.online · 
          <a href="/terms" className="mx-2 hover:text-blue-600">Terms & Privacy</a> · 
          Contact: <a href="mailto:admin@timelined.online" className="hover:text-blue-600">admin@timelined.online</a>
        </p>
      </div>
    </footer>
  )
}

export default Footer;